import script from "./CreateMemoFromPVPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateMemoFromPVPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateMemoFromPVPage.vue?vue&type=style&index=0&id=1d1fb279&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1fb279"]])

export default __exports__